module.exports = __webpack_public_path__ + "img/heima.87b21454.png";